import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marque une requete dont l'appelant prend l'erreur en charge lui-meme.
 * L'intercepteur global n'affiche alors aucun bandeau pour elle.
 *
 * odoo-8114 — une seule action de l'administrateur produisait jusqu'a trois
 * bandeaux empiles. La creation d'une mise a jour bibliotheque en affichait un
 * pour la recherche de checksum (qui echoue NORMALEMENT sur une URL
 * fournisseur, et que le code ignore volontairement), un pour le 400 de
 * l'enregistrement, et un troisieme pose par le composant par-dessus. Le
 * testeur voyait trois erreurs pour une cause, dont une qui n'en etait pas une.
 *
 * Deux usages legitimes :
 *
 *   1. **Une sonde** dont l'echec est un resultat attendu, pas une panne.
 *      Rien ne doit s'afficher.
 *   2. **Un appel dont le composant sait dire mieux** que le message
 *      generique — parce qu'il connait l'action en cours. Il affiche alors son
 *      propre message, construit avec `httpErrorMessage`, et un seul.
 *
 * Ne pas s'en servir pour taire une erreur qu'on ne traite pas : sans bandeau
 * ni traitement, l'echec devient invisible.
 */
export const SILENCE_HTTP_ERRORS = new HttpContextToken<boolean>(() => false);

/** Contexte pret a l'emploi pour les appels qui gerent leur propre erreur. */
export function silenceErrors(): HttpContext {
  return new HttpContext().set(SILENCE_HTTP_ERRORS, true);
}
